<div class="wrapper">
  <div class="container-fluid">

    <!-- start page title -->
    <div class="row">
      <div class="col-12">
        <div class="page-title-box">
          <div class="page-title-right">
            <ol class="breadcrumb m-0">
              <li class="breadcrumb-item"><a href="javascript: void(0);" routerLink="/management/participant">Participant</a></li>
              <li class="breadcrumb-item active">Edit Product Profiles</li>
            </ol>
          </div>
          <h4 class="page-title">Edit Participant Product Profiles</h4>
        </div>
      </div>
    </div>
    <!-- end page title -->


    <div class="row">
      <div class="col-12">

        <div *ngIf="!!participant" class="card-box">
          <form class="form-horizontal" role="form" autocomplete="off">

            <div class="form-group row">
              <div class="col-2">
                <label for="productProfiles" class="col-form-label">Product profiles</label>
              </div>
              <div *ngIf="!!mapCustomProductProfiles" id="productProfiles" class="col-6">
                <ng-select2 [(ngModel)]="selectedProductProfile" [ngModelOptions]="{standalone: true}"
                            [data]="mapCustomProductProfiles"
                            [options]="select2options" placeholder="Product profiles"></ng-select2>
              </div>
              <div class="col-4">
                <button class="btn btn-info waves-effect waves-light" (click)="addProductProfilesFields()" type="button">
                  Add Product Profiles<i class="mdi mdi-plus"></i></button>
              </div>
            </div>

            <ng-container *ngIf="productProfilesByParticipant && productProfilesByParticipant.length > 0">
              <div class="form-group row" *ngFor="let productProfilesFields of productProfilesByParticipant">

                <div class="col-2">
                  <label for="productProfile" class="col-form-label">Product Profile</label>
                </div>
                <div id="productProfile" class="col-2">
                  <ng-select2 [disabled]="true" [(ngModel)]="productProfilesFields.productProfileId"
                              [ngModelOptions]="{standalone: true}"
                              [data]="productProfiles" [options]="select2options" placeholder="Product profiles"></ng-select2>
                </div>

                <div class="col-2">
                  <label for="participantId" class="col-form-label">Participant
                    Id: {{productProfilesFields.participantId}}</label>
                </div>
                <div id="participantId" class="col-2">
                  <button class="btn btn-outline-warning  waves-effect waves-light mdi mdi-delete"
                          (click)="determineDeleteDialog(productProfilesFields.productProfileId)" type="button">Delete
                  </button>
                </div>

              </div>
            </ng-container>

            <div class="form-group row" offset-3 col-9 *ngIf="error">
              <div class="col-10">
                <p class="text-danger">{{errorMessage}}</p>
              </div>
            </div>
            <div class="form-group row offset-3 col-9" *ngIf="!!createResult && createResult.success == false">
              <ng-container *ngIf="!!createResult.message">
                <p class="text-danger">{{createResult.message}}</p>
              </ng-container>
            </div>


            <div class="form-group mb-0 justify-content-end row">
              <div class="col-9">
                <button type="submit" class="btn btn-info waves-effect waves-light float-right" (click)="save()">
                  Save
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
